import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersDimensionTextComponent extends BaseComponent2 {
    public readonly rootSelector = '.js_of_offers-dimension-text';

    public async onReloadComponentEvent(): Promise<unknown> {
        return Promise.resolve(undefined);
    }
}
